import React from 'react';
import { SectionWrapper, Card, Badge } from '../common';
import { packages } from '../../data/packages';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontSize: '22px',
    fontWeight: '600',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
    marginBottom: '16px',
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
    marginBottom: '8px',
  },
  currency: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#3b82f6',
  },
  amount: {
    fontSize: '48px',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
  },
  period: {
    fontSize: '16px',
    color: '#94a3b8',
  },
  ideal: {
    fontSize: '14px',
    color: '#94a3b8',
    marginBottom: '24px',
  },
  features: {
    listStyle: 'none',
    marginBottom: '32px',
    flex: 1,
  },
  feature: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px',
    color: '#cbd5e1',
    marginBottom: '12px',
  },
  checkIcon: {
    color: '#34d399',
    fontWeight: '700',
  },
};

export const Packages = ({ isVisible }) => {
  return (
    <SectionWrapper
      id="pakketten"
      label="Abonnementen"
      title="Kies jouw pakket"
      subtitle="Contract: 6 of 12 maanden"
      isVisible={isVisible}
      backgroundColor="rgba(15, 23, 42, 0.5)"
    >
      <div style={styles.grid}>
        {packages.map((pkg, i) => (
          <Card
            key={i}
            highlighted={pkg.popular}
            scaled={pkg.popular}
            style={styles.card}
          >
            {pkg.popular && <Badge variant="popular">Populair</Badge>}
            <h3 style={styles.name}>{pkg.name}</h3>
            <div style={styles.priceContainer}>
              <span style={styles.currency}>€</span>
              <span style={styles.amount}>{pkg.price}</span>
              <span style={styles.period}>/maand</span>
            </div>
            <p style={styles.ideal}>Ideaal voor: {pkg.ideal}</p>
            <ul style={styles.features}>
              {pkg.features.map((feature, j) => (
                <li key={j} style={styles.feature}>
                  <span style={styles.checkIcon}>✓</span>
                  {feature}
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>
    </SectionWrapper>
  );
};
